import React, { useState } from "react";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";
import { MdDelete, MdClose } from "react-icons/md";
import { operationVinculaCar } from "~/api";
import { formatCityName } from "~/utils/format";
import { trackEvent } from "~/utils/analytics";
import AoiUpload from "../AoiUpload";
import "./styles.scss";

const LOADING_SAVE = "LOADING_SAVE";

const AddCarToOperationModal = ({
  operationId,
  setError,
  onSuccess,
  onClose
}) => {
  const { formatMessage, formatNumber } = useIntl();
  const [aoiInfo, setAoiInfo] = useState(null);
  const [loadingStep, setLoadingStep] = useState(null);

  const handleExecute = async () => {
    setLoadingStep(LOADING_SAVE);

    if (!aoiInfo) {
      setError(formatMessage({ id: "validacao-kml" }));
      return;
    }

    const operationCar = {};
    operationCar.b3_proposta_id = operationId;
    operationCar.b3_area_id = aoiInfo.B3Area.id;

    try {
      await operationVinculaCar(operationCar);
      onSuccess();
    } catch (err) {
      const errorMessage = err.response?.data?.message;
      setError(
        errorMessage ? (
          <>
            {errorMessage}{" "}
            <Link to="/contact">
              {formatMessage({ id: "ir-para-contato" })}
            </Link>
          </>
        ) : (
          formatMessage({ id: "executar-analise-erro" })
        )
      );

      onClose();
    }

    setLoadingStep(null);
  };

  const openSICARLink = () => {
    trackEvent("click SICAR link");
    const url = "http://car.gov.br/publico/imoveis/index";
    window.open(url, "_blank");
  };

  return (
    <>
      <div className="modal add-car-modal is-active">
        <div className="modal-background"></div>
        <div className="modal-card">
          <header className="modal-card-head">
            <div className="modal-card-title">
              {formatMessage({ id: "cadastro-car" })}
            </div>
            <MdClose
              data-testid="close-button"
              className="close-button"
              onClick={onClose}
            />
          </header>
          <div className="modal-card-body">
            <div className="tile is-12 is-vertical input-info space-between">
              {aoiInfo ? (
                <>
                  {aoiInfo.Municipio && (
                    <p>
                      <span className="bold">
                        {formatMessage({ id: "municipio" })}:
                      </span>{" "}
                      {formatCityName(aoiInfo.Municipio)}
                    </p>
                  )}
                  {aoiInfo.B3Area && aoiInfo.B3Area.area_ha && (
                    <p>
                      <span className="bold">
                        {formatMessage({ id: "area" })}:
                      </span>
                      {` ${formatNumber(aoiInfo.B3Area.area_ha)} ha`}
                    </p>
                  )}
                </>
              ) : (
                <>
                  <p>
                    {formatMessage({
                      id: "aceitamos-formatos"
                    })}
                  </p>
                  <li>
                    {formatMessage(
                      {
                        id: "formato-sicar"
                      },
                      {
                        link: (
                          <button
                            className="link-button"
                            onClick={openSICARLink}
                          >
                            SICAR Nacional
                          </button>
                        )
                      }
                    )}
                  </li>
                </>
              )}
            </div>

            <div className="tile is-12 is-vertical">
              <AoiUpload aoiInfo={aoiInfo} setAoiInfo={setAoiInfo} />
            </div>

            {aoiInfo && (
              <div className="tile is-ancestor analysis-action-buttons">
                <div className="tile is-12 is-vertical">
                  <button
                    className={`remove-button full-width`}
                    onClick={() => setAoiInfo(null)}
                    disabled={loadingStep === LOADING_SAVE}
                  >
                    <MdDelete size={15} />{" "}
                    {formatMessage({ id: "remover-arquivo" })}
                  </button>
                  <button
                    className={`save-button full-width ${
                      loadingStep === LOADING_SAVE ? " is-loading" : ""
                    }`}
                    disabled={loadingStep === LOADING_SAVE}
                    onClick={() => handleExecute()}
                  >
                    {loadingStep === LOADING_SAVE ? (
                      <>{formatMessage({ id: "carregando" })}...</>
                    ) : (
                      <>{formatMessage({ id: "vincular-operacao" })}</>
                    )}
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default AddCarToOperationModal;
